import { useEffect } from 'react';

const ClarityScript = () => {

    useEffect(() => {

        const isInDevelopment = window.location.href.includes('localhost') || window.location.href.includes('192.168')

        if (!isInDevelopment) {

            (function (c, l, a, r, i, t, y) {
                c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
                t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
                y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
                console.log('script runed', window.location.href);
            })(window, document, "clarity", "script", "oc8bp22atx");

        }

    }, []);

    return null;
};

export default ClarityScript;